import { PlayerProfileBasic } from './PlayerProfileBasic';

export default PlayerProfileBasic;
